export const ATTACHMENTS_BUCKET =
  import.meta.env.VITE_ATTACHMENTS_BUCKET || "";

export const PROPOSALS_BUCKET =
  import.meta.env.VITE_PROPOSALS_BUCKET || "";
